import './App.css';
import FirstSection from './components/firstSection/firstSection';
import FivethSection from './components/fivethSection/fivethSection';
import Footer from './components/footer/footer';
import FourthSection from './components/fourthSection/fourthSection';
import SecondSection from './components/secondSection/secondSection';
import Section3 from './components/section3/section3';
import SectionEight from './components/sectionEight/sectionEight';
import SectionNine from './components/sectionNine/sectionNine';
import SectionSix from './components/sectionSix/sectionSix';
import SectionSeven from './components/severnSection/sectionSeven';
import ThirdSection from './components/thirdSection/thirdSection';
import MobileSlider from './mobileSlider/mobileSlider';
import Styled from 'styled-components';
// import CarosalComponent from './components/carosalComponent';

// const StyledContainer = Styled.div`
//   position: relative;
//   /* overflow:hidden; */
// `;

function App() {
  return (
    // <>
    // <StyledContainer> 
    //   <CarosalComponent/>
    // </StyledContainer>
    // </>
    <div className='App'>
        <FirstSection/> 
        <SecondSection/>
        <ThirdSection/>  
        <FourthSection/>
        <FivethSection/>    
        <SectionSix/>
        <SectionSeven/>
        <SectionEight/>
        <SectionNine/>
        <Footer/>        
        </div>

  );
}

export default App;
